import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import styled from 'styled-components';

const StyledHiddenButton = styled.button`
  position: fixed;
  bottom: 10px;
  left: 10px;
  width: 4px;
  height: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 9999;
  padding: 0;
  opacity: 0.01;
  transition: opacity 0.2s;

  &:hover,
  &:focus {
    opacity: 1;
    width: auto;
    height: auto;
    padding: 8px 12px;
    background: rgba(255, 0, 0, 0.8);
    color: white;
    border-radius: 4px;
    font-size: 12px;
  }
`;

const SentryTestButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      // Ctrl+Shift+S to toggle visibility
      if (event.ctrlKey && event.shiftKey && event.key === 'S') {
        event.preventDefault();
        setIsVisible((prev) => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const handleTestError = () => {
    try {
      throw new Error('Test Sentry Error - This is a test error for Sentry integration');
    } catch (error) {
      const exception = error instanceof Error ? error : new Error(String(error));
      Sentry.captureException(exception);
    }
  };

  const handleTestMessage = () => {
    Sentry.captureMessage('Test Sentry Message - This is a test message for Sentry integration', 'info');
  };

  if (!isVisible) {
    return (
      <StyledHiddenButton
        onClick={() => setIsVisible(true)}
        title="Click to show Sentry test buttons (or press Ctrl+Shift+S)"
        aria-label="Sentry test trigger"
      />
    );
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '10px',
        left: '10px',
        zIndex: 9999,
        display: 'flex',
        gap: '8px',
        flexDirection: 'column',
      }}
    >
      <button
        onClick={handleTestError}
        style={{
          padding: '8px 12px',
          background: '#ff4444',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
        }}
      >
        Test Sentry Error
      </button>
      <button
        onClick={handleTestMessage}
        style={{
          padding: '8px 12px',
          background: '#4444ff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
        }}
      >
        Test Sentry Message
      </button>
      <button
        onClick={() => setIsVisible(false)}
        style={{
          padding: '4px 8px',
          background: '#666',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '10px',
        }}
      >
        Hide
      </button>
    </div>
  );
};

export default SentryTestButton;
